export interface MediaFrame {
  src: string
  /** Short caption describing this step in the sequence. */
  caption: string
}

/**
 * Screenshots and walkthrough clips, keyed by the media-slot label they belong to.
 * A slot with more than one frame renders as a numbered, stacked sequence.
 * Slots without an entry here keep their "coming soon" placeholder.
 */
export const screenshots: Record<string, MediaFrame[]> = {
  'The login screen': [
    {
      src: 'https://cdn.magicpatterns.com/uploads/gDhTY1Q8FCytCAcCSToYns/loginss.png',
      caption: 'Sign into your account',
    },
  ],
  'Settings → My Staff → + Add User': [
    {
      src: 'https://cdn.magicpatterns.com/uploads/4u137FuVyNXWDjYynhGXvx/comet_hfrFdG0HNS.png',
      caption: 'Open Settings (bottom of the left-hand menu)',
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/nnYxM6v8Tmb2EvhMQ2PQv6/my-staff.png',
      caption: 'Choose "My Staff"',
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/kCoHQ55MYjQG51svQ7Qcko/add-user.gif',
      caption: 'Click "+ Add User" and fill in their details',
    },
  ],
  'The left-hand menu': [
    {
      src: 'https://cdn.magicpatterns.com/uploads/4SRmKHtXhV3tiLhFAnqxjn/crm-options.ss.png',
      caption: 'Your left-hand menu',
    },
  ],
  'The + Add Contact button': [
    {
      src: 'https://cdn.magicpatterns.com/uploads/bcRhbHWhxb3E4R1vnqNmXM/comet_zC0DY8hCCn.png',
      caption: '"Import" and "+ Add Contact" sit in the top right',
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/9Gf4EmjrxsS2mJGsdEotA3/comet_YxjAWVwSwn.gif',
      caption: 'Adding a contact from start to finish',
    },
  ],
  'Connect your calendar': [
    {
      src: 'https://cdn.magicpatterns.com/uploads/vZHnHdGsuFDtbsS9n8Nzfq/calendars-option.png',
      caption: 'Open Calendars from the left-hand menu',
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/b6awWFndbZ3xmx4xMUFfZZ/connections.png',
      caption: 'Go to the "Connections" tab',
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/kdsYrGbHmoiZJ5axSjVesa/add-new-calendar.png',
      caption: 'Click "+ Add new"',
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/i2RqXBJvaFwtZo1B7qSFD6/select-sync.png',
      caption: 'Hit "Connect" next to Google, Outlook, iCloud or Calendly',
    },
  ],
  'Social Planner — connect accounts': [
    {
      src: 'https://cdn.magicpatterns.com/uploads/t4GScc31PDhaUAbshXukUM/social-links-connect.png',
      caption: 'Click "+ Connect" under each network you use',
    },
  ],
  'Payments → Invoices → + New': [
    {
      src: 'https://cdn.magicpatterns.com/uploads/tVVydiR1ip2aKh5eno4heL/comet_wYoesxphxv.gif',
      caption: 'Creating and sending an invoice',
    },
  ],
  'AI Agents → Voice AI': [
    {
      src: 'https://cdn.magicpatterns.com/uploads/e9tu6mSbfND5PDuiEmK3Kp/ai-agent-demo.gif',
      caption: 'Where your Voice AI lives',
    },
  ],
  'AI Agents → agent & phone number': [
    {
      src: 'https://cdn.magicpatterns.com/uploads/hoG2iVjkoyhCgaHzpxiWaf/settings-phonesystem.png',
      caption: 'Settings → Phone System',
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/7J7qy2PD3XUR46uoTWLe4J/add-number.png',
      caption: 'Manage Numbers → "+ Add Number"',
    },
  ],
}

/** Screenshot shown on the Automation card in "Explore everything else". */
export const explorePreviews: Record<string, string> = {
  Automation: 'https://cdn.magicpatterns.com/uploads/uGUgAMTaFiUmVWECb69MVq/automate.png',
}
